import React from 'react';
import classNames from 'classnames';
import './SelectionAdorner.less';
import { IRect } from 'utils/GeometryUtils';

export interface ISelectionAdornerProps extends IRect {
  className?: string;
  /**
   * @default 0
   */
  zIndex?: number;
  /**
   * Indent between an element and the adorner
   *
   * @default 0
   */
  margin?: number;
}

/**
 * Indicates that element or group of elements are selected.
 * Can be used to create custom resize adorner.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function SelectionAdorner({
  className,
  children,
  margin = 0,
  left,
  top,
  width,
  height,
  zIndex = 0,
}: React.PropsWithChildren<ISelectionAdornerProps>) {
  return (
    <div
      className={classNames('dpc-selection-adorner', className)}
      style={{ ...inflate({ width, height, left, top }, margin), zIndex }}
    >
      {children}
    </div>
  );
}

interface SelectionAdornerRect {
  width: number;
  height: number;
  left: number;
  top: number;
}

function inflate(rect: SelectionAdornerRect, margin: number): SelectionAdornerRect {
  return {
    width: rect.width + margin * 2,
    height: rect.height + margin * 2,
    top: rect.top - margin,
    left: rect.left - margin,
  };
}
